import React from "react";
import Button from "components/CustomButtons/Button.jsx";
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { API } from '../config/config';
import axios from 'axios';
import { Spiner } from '../Spinner/Spinner';

export default class ContactUS extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        }
    }

    async submitForm(e) {
        e.preventDefault();
        this.setState({ loading: true });
        const formData = new FormData();
        formData.append("full_name", e.target.name.value);
        formData.append("email", e.target.email.value);
        formData.append("mobile", e.target.mobile.value);
        formData.append("text", e.target.comment.value);
        try {
            const response = await axios.post(`${API}/api/Contacts/Insert`, formData);
            // console.log(response);
            if (response.results !== 0) {
                alert('پیام شما با موفقیت ارسال گردید با تشکر .');
                this.setState({ loading: false });
                window.location.reload();
            }
        } catch (err) {
            console.log(err);
            this.setState({ loading: false });
            alert('ارسال با خطا مواجه شد لطفا مجددا سعی نمایید');
        }
    }

    render() {
        const { loading } = this.state;
        return (
            <div className="pages contentpage">
                {loading && <Spiner />}
                <Grid container spacing={16}>
                    <div className='contentTitle'>
                        <h3>
                            ارتباط با ما
                        </h3>
                    </div>
                </Grid>
                <Grid container className={'search-main-grid'} spacing={16}>
                    <Grid item sm={12} md={6} className='ex-detail-grid'>
                        <form onSubmit={this.submitForm.bind(this)} >
                            <Grid container className={'search-main-grid'} spacing={16}>
                                <Grid item sm={12} className='ex-detail-grid'>
                                    <p className='contactprag'>
                                        نظرات و انتقادات خود را برای ما ارسال کنید.
                                </p>
                                </Grid>
                                <Grid item xs={12} className='ex-detail-grid'>
                                    <TextField
                                        id="outlined-name"
                                        label="نام و نام خانوادگی"
                                        className='textfield'
                                        margin="normal"
                                        variant="outlined"
                                        name='name'
                                        required
                                        fullWidth
                                        onInvalid={(e) => e.target.setCustomValidity('نام و نام خانوادگی را وارد کنید')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} className='ex-detail-grid'>
                                    <TextField
                                        id="outlined-email"
                                        label="پست الکترونیکی"
                                        className='textfield'
                                        margin="normal"
                                        variant="outlined"
                                        name='email'
                                        fullWidth
                                        onInvalid={(e) => e.target.setCustomValidity('پست الکترونیکی را وارد کنید')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                        type='email'
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} className='ex-detail-grid'>
                                    <TextField
                                        id="outlined-mobile"
                                        label="تلفن همراه"
                                        className='textfield'
                                        margin="normal"
                                        variant="outlined"
                                        name='mobile'
                                        required
                                        fullWidth
                                        onInvalid={(e) => e.target.setCustomValidity('تلفن همراه را وارد کنید')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                        type='number'
                                    />
                                </Grid>
                                <Grid item xs={12} className='ex-detail-grid'>
                                    <TextField
                                        id="outlined-comment"
                                        label="متن پیام"
                                        className='textfield commenttext'
                                        margin="normal"
                                        variant="outlined"
                                        name='comment'
                                        fullWidth
                                        multiline
                                        rowsMax={10}
                                        required
                                        onInvalid={(e) => e.target.setCustomValidity('متن پیام را وارد کنید')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container className={'search-main-grid'} spacing={16}>
                                <Button className='search-but' type='submit'>
                                    ارسال
                                </Button>
                            </Grid>
                        </form>
                    </Grid>
                    <Grid item sm={12} md={6} className='ex-detail-grid'>
                        <div className='contactphone' >
                            <img src='/phone.png' alt='contact-phone' />
                        </div>
                    </Grid>
                </Grid>

            </div>
        );
    }
}

